import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/components/shared/confirmation-dialog/confirmation-dialog.component';
import { DialogOptions } from "../../../interfaces/shared/dialog-options.interface";
import { firstValueFrom } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class ConfirmationDialogService {

  constructor(
    private dialog: MatDialog
  ) { }

  // ---------------------------------------------------------------
  // MÉTODO ANTIGUO!! (Lo mantenemos para casos especiales, por favor utilizar los otros en nuevos desarrollos)
  // ---------------------------------------------------------------
  public confirm(
    title: string,
    message: string,
    subMessage?: string,
    icon?: string,
    btnOkText: string = 'Aceptar',
    btnCancelText: string = 'Cancelar',
    dialogSize: 'sm' | 'lg' = 'lg',
    showComment: boolean = false): Promise<boolean> {
    const dialogWidth = dialogSize === 'sm' ? '400px' : '800px';
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: dialogWidth,
      disableClose: true,
      data: {
        icon: icon,
        title: title,
        message: message,
        subMessage: subMessage,
        btnOkText: btnOkText,
        btnCancelText: btnCancelText,
        showComment: showComment
      }
    });
    return firstValueFrom(dialogRef.afterClosed());
  }

  // ---------------------------------------------------------------
  // MÉTODO GENÉRICO (Lo mantenemos para casos no comunes)
  // ---------------------------------------------------------------
  public confirmAux(options: DialogOptions): Promise<boolean> {
    const dialogWidth = options.dialogSize === 'sm' ? '400px' : options.dialogSize === 'xl' ? '1200px' : '800px';
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: dialogWidth,
      disableClose: true,
      data: options
    });

    return firstValueFrom(dialogRef.afterClosed());
  }

  // ---------------------------------------------------------------
  // MÉTODO ESPECIALIZADO PARA BORRAR
  // ---------------------------------------------------------------
  public confirmDelete(customMessage?: string): Promise<boolean> {
    const options: DialogOptions = {
      title: 'Borrar',
      message: customMessage || '¿Estás seguro que desea eliminar los elementos seleccionados?',
      btnOkText: 'BORRAR',
      btnCancelText: 'Cancelar',
      showComment: true,
      commentLabel: 'Motivo de la eliminación',
      commentRequired: true
    };
    return this.confirmAux(options);
  }

  // ---------------------------------------------------------------
  // MÉTODO ESPECIALIZADO PARA MODIFICAR/EDITAR
  // ---------------------------------------------------------------
  public confirmEdit(dynamicMessagePart?: string): Promise<boolean> {
    const options: DialogOptions = {
      title: 'Modificación',
      message: dynamicMessagePart ? `¿Desea confirmar los cambios realizados en ${dynamicMessagePart}?` : `¿Desea confirmar los cambios realizados?`,
      btnOkText: 'Aceptar',
      btnCancelText: 'Cancelar',
      showComment: true // Siempre requerirá comentario para editar
    };
    return this.confirmAux(options);
  }

  // ---------------------------------------------------------------
  // MÉTODO ESPECIALIZADO PARA CREAR
  // ---------------------------------------------------------------
  public confirmCreate(dynamicMessagePart?: string): Promise<boolean> {
    const options: DialogOptions = {
      title: 'Crear',
      message: dynamicMessagePart ? `¿Desea confirmar los cambios realizados en ${dynamicMessagePart}?` : `¿Desea confirmar los cambios realizados?`,
      btnOkText: 'Aceptar',
      btnCancelText: 'Cancelar',
      showComment: true // Siempre requerirá comentario para editar
    };
    return this.confirmAux(options);
  }

  // ---------------------------------------------------------------
  // MÉTODO ESPECIALIZADO PARA ACCIONES SIMPLES (SIN COMENTARIO)
  // ---------------------------------------------------------------
  public confirmAction(title: string, message: string, subMessage?: string): Promise<boolean> {
    const options: DialogOptions = {
      title: title,
      message: message,
      subMessage: subMessage ? subMessage : '',
      btnOkText: 'Aceptar',
      btnCancelText: 'Cancelar',
      showComment: false
    };
    return this.confirmAux(options);
  }



  public confirmActionGeneral(title: string, message: string, options?: any): Promise<boolean> {
    const dialogWidth = options?.dialogSize === 'sm' ? '400px' : '800px';
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: dialogWidth,
      disableClose: true,
      data: {
        icon: options?.icon,
        title: title,
        message: message,
        btnOkText: options?.buttonPrimary || 'Aceptar',
        btnCancelText: options?.buttonSecondary || 'Cancelar',
        options: options
      }


    });

    return firstValueFrom(dialogRef.afterClosed());
  }




  // ---------------------------------------------------------------
  // MÉTODO ESPECIALIZADO PARA ACCIONES SIMPLES (SIN COMENTARIO)
  // ---------------------------------------------------------------
  public confirmActionWithComment(title: string, message: string, subMessage?: string): Promise<boolean> {
    const options: DialogOptions = {
      title: title,
      message: message,
      subMessage: subMessage ? subMessage : '',
      btnOkText: 'Aceptar',
      btnCancelText: 'Cancelar',
      showComment: true
    };
    return this.confirmAux(options);
  }

  // ---------------------------------------------------------------
  // MÉTODO ESPECIALIZADO PARA CANCELAR EDICION (SIN COMENTARIO)
  // ---------------------------------------------------------------
  public cancelEdit(): Promise<boolean> {
    const options: DialogOptions = {
      title: "¿Descartar cambios?",
      message: "Si sale ahora, se perderán las modificaciones que realizó.",
      btnOkText: 'Descartar',  // Botón principal (azul, derecha)
      btnCancelText: 'Seguir editando',
      showComment: false
    };
    return this.confirmAux(options);
  }

  // ---------------------------------------------------------------
  // MÉTODO ESPECIALIZADO PARA ELIMINAR OBSERVACIÓN ANTERIOR (CON 3 OPCIONES)
  // ---------------------------------------------------------------
  public confirmDeleteObservacionAnterior(): Promise<boolean | string> {
    const options: DialogOptions = {
      title: "Borrar",
      message: "¿Está generando un nuevo registro, desea eliminar el anterior?",
      subMessage: "*Al hacer clic en Eliminar, se eliminará el registro que estaba visualizando recientemente.",
      btnOkText: 'No Eliminar',      // Botón principal (azul, derecha)
      btnCancelText: 'Eliminar',     // Botón secundario (rojo, centro)
      btnThirdText: 'Cancelar operación',  // Botón terciario (izquierda)
      showComment: false
    };
    return this.confirmAux(options);
  }


}
